import React, { useState } from 'react';
import {
  Box,
  TextField,
  Typography,
  Grid,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { SendMoneyListDto } from '../../../types/approval.types';
import { formatMoney, formatMoneyForTable, currencyToForm } from '../../../utils/approvalUtils';

interface SendMoneyCancelDetailProps {
  data: SendMoneyListDto;
  rejectionReason: string;
  onReasonChange: (reason: string) => void;
  onSubmit: () => void;
  isLoading: boolean;
}

const SendMoneyCancelDetail: React.FC<SendMoneyCancelDetailProps> = ({
  data,
  rejectionReason,
  onReasonChange,
  onSubmit,
  isLoading
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Data kontrolü - eğer Data yoksa veya array değilse boş döndür
  if (!data || !data.Data || !Array.isArray(data.Data) || data.Data.length === 0) {
    return null;
  }

  return (
    <Box>
      <Accordion expanded={isExpanded} onChange={() => setIsExpanded(!isExpanded)}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography variant="subtitle1">İşlem Detayı</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {data.Data.map((item, index) => (
            <Box key={index} sx={{ mb: index < data.Data.length - 1 ? 3 : 0 }}>
              {data.Data.length > 1 && (
                <Typography variant="h6" sx={{ mb: 2 }}>
                  İşlem {index + 1}
                </Typography>
              )}
              
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Alıcı Hesap No"
                    value={item.ReceiverWalletNo || ''}
                    disabled
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Tutar"
                    value={formatMoneyForTable(item.Value, currencyToForm(item.CurrencyId))}
                    disabled
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Komisyon"
                    value={formatMoney(item.ValueFee)}
                    disabled
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Toplam"
                    value={formatMoney(item.Value + item.ValueFee)}
                    disabled
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Para Birimi"
                    value={currencyToForm(item.CurrencyId)}
                    disabled
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Açıklama"
                    value={item.Description}
                    disabled
                    variant="outlined"
                    size="small"
                    multiline
                    rows={3}
                  />
                </Grid>
              </Grid>
            </Box>
          ))}
        </AccordionDetails>
      </Accordion>

      <Box sx={{ mt: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="İptal Nedeni"
              value={rejectionReason}
              onChange={(e) => onReasonChange(e.target.value)}
              variant="outlined"
              size="small"
              required
              error={!rejectionReason.trim()}
              helperText={!rejectionReason.trim() ? 'Lütfen iptal nedenini giriniz' : ''}
            />
          </Grid>
          
          {/* <Grid item xs={12}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                variant="contained"
                color="error"
                onClick={onSubmit}
                disabled={!rejectionReason.trim() || isLoading}
              >
                İptal
              </Button>
            </Box>
          </Grid> */}
        </Grid>
      </Box>
    </Box>
  );
};

export default SendMoneyCancelDetail;
